
import React, { useEffect, useState } from 'react';
import { detectDeviceAndOS } from '@/utils/utils';
import '@/utils/i18n';
import { useTranslation } from 'react-i18next'; 
import Home from '@/pages/Home';
// import Moblie from '@/pages/Moblie'; 
// const Home = React.lazy(() => import('@/pages/Home'))
const Moblie = React.lazy(() => import('@/pages/Moblie'))


const { isDesktop , sysOs} = detectDeviceAndOS();
function App() {
    const { t, i18n } = useTranslation();
    const [switchPageKey, setSwitchPageKey] = useState(isDesktop);
    useEffect(() => {
        init();
        const handleResize = () => {
            if (isDesktop) {
                setSwitchPageKey(window.innerWidth > 640 );
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        // 清理事件监听器
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const init = async () => {
        const userLang = navigator.language.toLowerCase();
        const langAbbreviate = userLang.split('-')[0];
        let lang = 'zh';
        if(langAbbreviate==='zh'){
            lang = 'zh-TW';
            if(userLang.endsWith('-cn')){
                lang = 'zh';
            }
        }else{
            lang = 'en'// langAbbreviate;
        }
        console.log('userLang', userLang, lang)
        i18n.changeLanguage(lang)
        

        setTimeout(() => {        
            window.top.document.title = t('pageTitle')
            // if(userLang.indexOf('ar')===0){
            //     window.document.body.style.direction = 'rtl'
            //     window.document.body.style.textAlign = 'right'
            // }
        }, 100);
    }
    return (
        <>
            {
                switchPageKey ? <Home t={t} /> : <Moblie  t={t} sysOs={sysOs} />
            }
        </>
    );
}
export default App;